import { render, staticRenderFns } from "./tableIndex.vue?vue&type=template&id=c0d55fca&scoped=true&"
import script from "./tableIndex.vue?vue&type=script&lang=js&"
export * from "./tableIndex.vue?vue&type=script&lang=js&"
import style0 from "./tableIndex.vue?vue&type=style&index=0&id=c0d55fca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d55fca",
  null
  
)

export default component.exports